import React from 'react';
import type { PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import useHashParam from 'use-hash-param';

import { useAuth } from '@reckon-web/auth-store';

import { isSecureRoute } from '../Navigation';
export type PortalUrlFragmentManagerProps = PropsWithChildren<{}>;

export const PortalUrlFragmentManager = ({
  children,
}: PortalUrlFragmentManagerProps) => {
  const router = useRouter();
  const [accessToken] = useHashParam('accessToken', '');
  const [refreshToken] = useHashParam('refreshToken', '');

  const {
    credentials,
    setCredentials,
    logout,
    isAuthenticated,
    isLoading,
    setIsLoading,
  } = useAuth();

  React.useEffect(() => {
    if (!isSecureRoute(router.pathname)) {
      setIsLoading(false);
    } else if (!!isLoading && !!accessToken && accessToken !== 'null') {
      setCredentials({ accessToken, refreshToken });
      setIsLoading(false);
    } else if (!!isLoading && isAuthenticated) {
      setIsLoading(false);
    } else if (!isAuthenticated) {
      logout({ reasonCode: 'INVALID_TOKEN' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    accessToken,
    credentials?.accessToken,
    isLoading,
    refreshToken,
    router.pathname,
    setCredentials,
  ]); // intentionally missing some deps as they end up causing infinite rerenders

  return <>{children}</>;
};
